import {
    ResultObj,
    allFetch
} from "../Domain";


export interface ImportDutyParams {
    ImportDuty_objs: { code: string, name: string, ul_id?: string, is_calculate_salary?: "Y" | "N" }[]
}

export interface ImportAccountParams {
    ImportAccount_objs: {
        username: string,
        name: string,
        gender?: string,
        identity_card?: string,
        birthday?: string,
        telephone?: string,
        mobile_phone?: string,
        email?: string,
        city?: string,
        area?: string,
        address?: string,
        city_census?: string,
        area_census?: string,
        address_census?: string,
        on_board_date?: string,
        note?: string,
        blood_type?: string,
    }[]
}

export interface ImportLevelParams {
    ImportLevel_objs: {
        code: string,
        name: string,
        parent_id: string,
        company_id?: string,
        general_manager_id?: string,
        department_id?: string,
        position_id?: string,
        class_id?: string,
        group_id?: string,
        office_id?: string,
        email?: string,
        phone?: string,
        salary_type?: string,
        title?: string,
        maximum?: string,
        lowest_ucr_id?: string,
        lowest_career_level?: string,
        leave_day_audit?: string,
        note?: string,
        order_over_discount_audit?: string,
    }[]
}

type ImportAppointment_objs = {
    Plant: string,
    vin_no: string,
    license_plate: string,
    driver_name?: string,
    driver_phone?: string,
    customer_name: string,
    customer_phone: string,
    appointment_no: string,
    appointment_time: string,
    content?: string,
    note?: string,
}

export type ImportPotentialCustomer_obj = {
    dealer: string,
    class_name?: string,
    chance_number: string,
    saler_username: string,
    saler_name: string,
    status: string,
    isreserve?: string,
    potential_customer_name: string,
    car_type_codes?: string,
    car_type_names?: string,
    source?: string,
    medium?: string,
    introducer?: string,
    level?: string,
    contact?: string,
    phone1?: string,
    phone2?: string,
    cellphone?: string,
    address_contact?: string,
    create_date: '',
    predict_purchase_date?: string,
    update_date?: string,
    project_code?: string,
    quotation_date?: string,
    reserve_date?: string,
    test_drive_date?: string,
    last_contact_date?: string,
    last_contact_purpose?: string,
    next_contact_date?: string,
    next_contact_purpose?: string,
    co_saler_name?: string,
    email?: string,
    defeat_brand?: string,
    defeat_car_type?: string,
    defeat_reason?: string,
    birthday?: string,
    industry_type?: string,
    purchase_status?: string,
    purchase_purpose?: string,
    payment?: string,
    sale_type?: string,
    budget_range?: string,
    competition_brand?: string,
    competition_car_type?: string,
    own_brand?: string,
    own_car_type?: string,
    consider_factors?: string,
    order_number?: string,
    order_audit_date?: string,
    order_car_type?: string,
    note?: string,
    contact_methods?: string,
    first_contact_date?: string,
    first_contact_purpose?: string,
    is_personal_info_auth?: string,
    unauth_type?: string,
}

export interface ImportAppointmentParams { ImportAppointment_objs: ImportAppointment_objs[] }
export interface ImportAppointmentProcessParams { ImportAppointment_objs: ImportAppointment_objs[] }
export interface ImportCalendarParams { cm_id: string, year: string, ImportCalendar_objs: { date: string, note: string }[] }
export interface ImportAppointmentSearchParams { page: string, num_per_page: string }
export interface ImportPotentialCustomerParams { ImportPotentialCustomer_objs: ImportPotentialCustomer_obj[] }
export interface ImportNewCarStockParams { ImportNewCarStock_objs: ImportNewCarStockObj[] }
export interface ImportCarComponentParams { ImportCarComponent_objs: ImportCarComponentObj[] }


/**
 * 用來當成API參數的值丟出去的格式規範、需求
 * @param {string} classification                   車輛分類
 * @param {string} status                           狀態
 * @param {string} produce_station                  生產站別
 * @param {string} dealer                           經銷商
 * @param {string} store_department                 存放部門
 * @param {string} store_space                      儲位
 * @param {string} car_type_code                    車型代碼
 * @param {string} car_type_name                    車型名稱
 * @param {string} year                             年式
 * @param {string} exterior_code                    外裝代碼
 * @param {string} exterior_color                   外裝顏色
 * @param {string} interior_code                    內裝代碼
 * @param {string} interior_color                   內裝顏色
 * @param {string} day                              天數
 * @param {string} manufacture_date                 製造年月
 * @param {string} predict_offline_date             預計下線日期
 * @param {string} predict_dispatch_date            預計出車日期
 * @param {string} dispatch_date                    出車日期
 * @param {string} leave_factory_date               出廠日期
 * @param {string} onboard_date                     出船日期
 * @param {string} predict_arrive_port_date         預計到港日
 * @param {string} arrive_port_date                 到港日期
 * @param {string} data_transfer_date               資料轉入日期
 * @param {string} check_date                       點收日期
 * @param {string} general_agent_dispatch_datetime  總代理配車日期
 * @param {string} repayment_date                   還款日期
 * @param {string} stock_usage                      庫存用途
 * @param {string} brand                            品牌
 * @param {string} SIDO_no                          SIDO號碼
 * @param {string} vin_no                           VIN號碼
 * @param {string} engine_no                        引擎號碼
 * @param {string} body_code_no                     車身號碼
 * @param {string} transaction_type                 交易類別
 * @param {string} transaction_code                 交易單號
 * @param {string} car_owner_name                   車主姓名
 * @param {string} saler_name                       銷售人員姓名
 * @param {string} transaction_datetime             交易時間
 * @param {string} transaction_date                 交易日期
 * @param {string} employee_name                    員工姓名
 * @param {string} reserve_reason                   保留原因
 * @param {string} reserve_department               保留部門
 * @param {string} reserve_employee                 保留員工
 * @param {string} reserve_note                     保留備註
 * @param {string} stock_card_code                  庫存卡號
 * @param {string} target                           對象
 * @param {string} deposit_code                     寄存區代碼
 * @param {string} deposit_date                     寄存日期
 * @param {string} quality_control_date             品管紀錄日期
 * @param {string} quality_control_mileage          品管紀錄里程
 * @param {string} quality_control_reason           品管記錄原因
 */
export interface ImportNewCarStockObj {
    classification: string,
    status: string,
    produce_station: string,
    dealer: string,
    store_department: string,
    store_space: string,
    car_type_code: string,
    car_type_name: string,
    year: string,
    exterior_code: string,
    exterior_color: string,
    interior_code: string,
    interior_color: string,
    day: string,
    manufacture_date: string,
    predict_offline_date: string,
    predict_dispatch_date: string,
    dispatch_date: string,
    leave_factory_date: string,
    onboard_date: string,
    predict_arrive_port_date: string,
    arrive_port_date: string,
    data_transfer_date: string,
    check_date: string,
    general_agent_dispatch_datetime: string,
    repayment_date: string,
    stock_usage: string,
    brand: string,
    SIDO_no: string,
    vin_no: string,
    engine_no: string,
    body_code_no: string,
    transaction_type: string,
    transaction_code: string,
    car_owner_name: string,
    saler_name: string,
    transaction_datetime: string,
    transaction_date: string,
    employee_name: string,
    reserve_reason: string,
    reserve_department: string,
    reserve_employee: string,
    reserve_note: string,
    stock_card_code: string,
    target: string,
    deposit_code: string,
    deposit_date: string,
    quality_control_date: string,
    quality_control_mileage: string,
    quality_control_reason: string
}

/**
 * @param {string} component_type   零件種類    必填!
 * @param {string} front_code       前段代碼    必填!
 * @param {string} mid_code         中段代碼    必填!
 * @param {string} back_code        後段代碼    必填!
 * @param {string} component_name   品名        必填!
 * @param {number} service_price    服務廠售價
 * @param {number} newcar_price     新車優惠價
 * @param {string} valid_date       生效時間
 * @param {string} stop_sale_date   停賣時間
 */
export interface ImportCarComponentObj {
    component_type: string;
    front_code: string;
    mid_code: string;
    back_code: string;
    component_name: string;
    service_price: number;
    newcar_price: number;
    valid_date: string;
    stop_sale_date: string;
}

// export interface ImportPDICarStockParams {
//     saleable?: string,
//     status?: string,
//     transaction_code?: string,
//     car_type: string,
//     format_code?: string,
//     format_name?: string,
//     year?: string,
//     exterior_code?: string,
//     exterior_color?: string,
//     interior_code?: string,
//     interior_color?: string,
//     FO: string,
//     vin_no?: string,
//     body_code_no?: string,
//     predict_arrive_port_date?: string,
//     upd_time?: string,
//     special_equipment?: string,
//     note?: string,
//     invoice_date?: string,
//     store_department?: string,
//     store_space?: string,
// }

/**
 * @description 職責excel匯入
 */
export const ImportDuty = async (params: ImportDutyParams): Promise<ResultObj> => await allFetch('ImportData/ImportDuty', params);

/**
 * @description 帳號excel匯入
 */
export const ImportAccount = async (params: ImportAccountParams): Promise<ResultObj> => await allFetch('ImportData/ImportAccount', params);

/**
 * @description 職務excel匯入
 */
export const ImportLevel = async (params: ImportLevelParams): Promise<ResultObj> => await allFetch('ImportData/ImportLevel', params);

/**
 * @description 預約excel匯入
 */
export const ImportAppointment = async (params: ImportAppointmentParams): Promise<ResultObj> => await allFetch('ImportData/ImportAppointment', params);

/**
 * @description 預約excel匯入
 */
export const ImportAppointmentProcess = async (params: ImportAppointmentProcessParams): Promise<ResultObj> => await allFetch('ImportData/ImportAppointmentProcess', params);

/**
 * @description 行事曆excel匯入
 */
export const ImportCalendar = async (params: ImportCalendarParams): Promise<ResultObj> => await allFetch('ImportData/ImportCalendar', params);

/**
 * @description 預約excel查詢
 */
export const ImportAppointmentSearch = async (params: ImportAppointmentSearchParams): Promise<ResultObj> => await allFetch('ImportData/ImportAppointmentSearch', params);

/**
 * @description 上傳車源
 */
export const ImportPDICarStock = async (params: FormData): Promise<ResultObj> => await allFetch<FormData>('ImportData/ImportPDICarStock', params);


/**
 * @description 上傳車源
 */
export const ImportNewCarStock = async (params: ImportNewCarStockParams): Promise<ResultObj> =>
    await allFetch('ImportData/ImportNewCarStock', params);

export const ImportCarComponent = async (params: ImportCarComponentParams): Promise<ResultObj> =>
    await allFetch('ImportData/ImportCarComponent', params);

/**
 * 車源匯入
 * @param params 
 * @returns 
 */
export const ImportCarStock = async (params: FormData): Promise<ResultObj> => {
    return await allFetch<FormData>('ImportData/ImportCarStock', params);
}




/**
 * @description 潛客excel匯入
 */
export const ImportPotentialCustomer = async (params: FormData): Promise<ResultObj> =>
    await allFetch<FormData>('ImportData/ImportPotentialCustomer', params);


/**
 * 這是瑞達的
 * @description 配件excel匯入
 */
export const ImportCarComponentRDE = async (params: FormData): Promise<ResultObj> =>
    await allFetch<FormData>('ImportDataRDE/ImportCarComponentRDE', params);
